import { render, staticRenderFns } from "./FollowItem.vue?vue&type=template&id=1d17c2f6&scoped=true&lang=true"
import script from "./FollowItem.vue?vue&type=script&lang=js"
export * from "./FollowItem.vue?vue&type=script&lang=js"
import style0 from "./FollowItem.vue?vue&type=style&index=0&id=1d17c2f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d17c2f6",
  null
  
)

export default component.exports